import React from "react";

export default function Loading(props) {
  return (
    <>
      <div
        className="backdrop visible active"
        style={{ display: props.show === true ? "" : "none" }}
      />

      <div
        className="loading-container visible active"
        style={{ display: props.show === true ? "" : "none" }}
      >
        <div className="loading">
          <span>{props.children}</span>
        </div>
      </div>
    </>
  );
}
